<template>
	<div class="sampleAssignment">
		<PageHeader @back="goback" :content="'样本指派'" />
		<div class="sampleAssignmentBox">
			<div class="assigningBtn">
				<el-tooltip class="item" effect="light" content="请选择‘全部样本’并勾选样本" placement="top">
					<el-button :disabled="chooseUserId != 'all' || (chooseUserId == 'all' && wantToSelect.length == 0)" size="medium" type="primary" @click="dialogVisible = true">
						分配样本<span v-if="chooseUserId == 'all' && wantToSelect.length > 0">（{{ wantToSelect.length }}）</span>
					</el-button>
				</el-tooltip>
				<el-tooltip class="item" effect="light" content="请选择‘访员’并勾选样本" placement="top">
					<el-button :disabled="chooseUserId == 'all' || (chooseUserId != 'all' && wantToSelect.length == 0)" size="medium" type="primary" @click="cancelAllot">
						取消分配<span v-if="chooseUserId != 'all' && wantToSelect.length > 0">（{{ wantToSelect.length }}）</span>
					</el-button>
				</el-tooltip>
			</div>
			<div class="topTableBox">
				<el-table class="topLeft" max-height="400" highlight-current-row border :data="InterviewerSamleCountData" @cell-click="cellClick">
					<el-table-column align="center" fixed label="选择访员">
						<template slot-scope="scope">
							<span :class="chooseUserId == scope.row.userId ? 'checkedTrue' : 'checkedFalse'" @click="chooseInterviewer(scope.row)">
								<el-radio v-model="chooseUserId" :label="scope.row.userId">{{ scope.row.userName }} ( {{ scope.row.count }}个 )</el-radio>
							</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="topRight">
					<el-table border :data="wantToAllotSampleListData" @selection-change="wantToChange">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column
							v-for="item in columnList"
							:key="item.enfieldName"
							align="center"
							:prop="item.enfieldName"
							:label="item.chfieldName"
							:fixed="item.fixed"
						></el-table-column>
						<!-- <el-table-column align="center" fixed prop="id" label="样本编号"></el-table-column>
						<el-table-column align="center" prop="isDesc" label="样本状态"></el-table-column>
						<el-table-column align="center" prop="isDesc" label="手机号"></el-table-column>
						<el-table-column align="center" prop="isDesc" label="区号"></el-table-column>
						<el-table-column align="center" prop="isDesc" label="分机号"></el-table-column> -->
						<el-table-column align="center" fixed="right" label="操作" width="120">
							<template slot-scope="scope">
								<el-link type="primary" :underline="false" @click="viewDetails(scope)">查看样本</el-link>
							</template>
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination
							background
							@size-change="wantToAllotSamplePaginationSizeChange"
							@current-change="wantToAllotSamplePaginationCurrentChange"
							:current-page="wantToAllotSamplePagination.pageNo"
							:page-sizes="[5, 10, 50, 100, 200, 300, 400]"
							:page-size="wantToAllotSamplePagination.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="wantToAllotSamplePagination.total"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
		<!-- 查看详情 修改样本 -->
		<particulars ref="particulars" :fieldContrast="fieldContrast"></particulars>

		<!-- 选择样本要指派的专家 -->
		<el-dialog title="选择访员" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
				<el-form-item label="访员：" prop="userId">
					<el-select style="width: 100%;" size="medium" v-model="ruleForm.userId" placeholder="请选择样本分配的访员">
						<template v-for="info in InterviewerSamleCountData" >
							<el-option v-if="info.userId != 'all'" :key="info.userId" :label="info.userName" :value="info.userId"></el-option>
						</template>
					</el-select>
				</el-form-item>
			</el-form>


			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="cancel('ruleForm')">取消</el-button>
				<el-button size="medium"  type="primary" :loading="chooseAllotLoading" @click="chooseAllot('ruleForm')">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import particulars from './particulars.vue';
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		particulars,
		PageHeader
	},
	data() {
		return {
			source:'',
			columnList:[],//动态表头
			fieldContrast: [],
			chooseUserId: 'all', //选择用户
			allSamples: 0,

			// 右侧选择被指派样本
			wantToSelect: [], //选择分配样本数据
			wantToAllotSampleListData: [],
			wantToAllotSamplePagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			// 左侧选择访员
			InterviewerSamleCountData: [],
			//左侧选择访员end
			id: '',
			dialogVisible: false,
			ruleForm: {
				userId: ''
			},
			rules: {
				userId: [
					{ required: true, message: '请选择访员', trigger: 'change' }
				],
			},
			chooseAllotLoading: false
		};
	},
	computed: {
		selectIndex() {
			let state
			if (this.$route.query.source == 'df') {
				state = 3
			}else if (this.$route.query.source == 'mf') {
				state = 4
			}
			return state
		}
	},
	created() {
		this.id = this.$route.query.id;
		this.source = this.$route.query.source
		this.queryInterviewerSamleCount(); //查询访员名字以及访员分配样本个数
		this.queryAllotSampleList(); //已被指派样本列表
		this.queryWantToAllotSampleList(); //选择被指派样本列表
		this.queryFieldConfig();//动态表头
	},
	methods: {
		cellClick(e) {
			console.log('e :>> ', e);
			this.chooseUserId = e.userId
			this.chooseInterviewer(e)
		},
		queryFieldConfig() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFieldConfig}`,
				method: 'POST',
				data: {
					qid: this.id,
					source:this.source
				},
				cb(res) {
					console.log('查询左中右', res);
					if (res.code == 0) {
						if (res.resultBody != '') {
							let leftList = JSON.parse(res.resultBody.leftFieldName);
							let centreList = JSON.parse(res.resultBody.centreFieldName);
							let rigthList = JSON.parse(res.resultBody.rightFieldName);
							leftList.forEach(item => {
								item.fixed = 'left';
							});
							rigthList.forEach(item => {
								item.fixed = 'rigth';
							});
							console.log(leftList, centreList, rigthList);
		
							let tempAllList = [...leftList, ...centreList, ...rigthList];
							that.activeHide = false;
							tempAllList.forEach((item, index) => {
								if (item.chfieldName == '操作') {
									tempAllList.splice(index, 1);
									that.activeHide = true;
								}
							});
							that.columnList = tempAllList;
						} else {
							that.columnList = [];
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		querySampleDetails(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.querySampleDetails}`,
				method: 'POST',
				data: {
					qid: this.id,
					sampleCode: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('res',res.resultBody);
						that.$refs.particulars.disabled = true;
						that.$refs.particulars.title = '查看详情';
						that.$refs.particulars.form =res.resultBody;
						that.$refs.particulars.loadData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		viewDetails(scope) {
			console.log(scope.row)
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					if (res.code == 0) {
						that.fieldContrast = res.resultBody.questionsFieldMappings;
						that.querySampleDetails(scope.row.id);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 取消分配
		cancelAllot() {
			if (this.chooseUserId == '') {
				this.$message.warning('请选择访员');
				return false;
			}
			console.log('this.wantToSelect :>> ', this.wantToSelect);
			if (this.wantToSelect.length == 0) {
				this.$message.warning('请选择要取消的样本');
				return false;
			}
			let data = {
				surveyId: this.id,
				userId: this.chooseUserId,
				sampleId: this.wantToSelect.toString(),
				source:this.source
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.recallAllotSample}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						that.wantToSelect = [];
						that.queryInterviewerSamleCount(); //查询访员名字以及访员分配样本个数
						that.queryAllotSampleList(that.chooseUserId); //已被指派样本列表
						that.queryWantToAllotSampleList(); //选择被指派样本列表
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 选择被指派样本
		cancel(formName) {
			this.wantToSelect = [];
			this.$refs[formName].resetFields();
			this.dialogVisible = false
		},
		chooseAllot(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.chooseAllotLoading = true
					let data = {
						surveyId: this.id,
						userId: this.ruleForm.userId,
						sampleId: this.wantToSelect.toString()
					};
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.allotSample}`,
						method: 'POST',
						data: data,
						cb(res) {
							if (res.code == 0) {
								console.log(res);
								that.cancel(formName)
								that.queryInterviewerSamleCount(); //查询访员名字以及访员分配样本个数
								that.queryAllotSampleList(that.chooseUserId); //已被指派样本列表
								that.queryWantToAllotSampleList(); //选择被指派样本列表
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						},
						finally() {
							that.chooseAllotLoading = false
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		wantToChange(val) {
			console.log(val);
			let tempWantTo = [];
			val.forEach(item => {
				tempWantTo.push(item.id);
			});
			this.wantToSelect = tempWantTo;
		},
		wantToAllotSamplePaginationSizeChange(val) {
			this.wantToAllotSamplePagination.pageSize = val;
			this.wantToAllotSamplePagination.pageNo = 1;
			if (this.chooseUserId == 'all') {
				this.queryWantToAllotSampleList();
			} else {
				this.queryAllotSampleList(this.chooseUserId);
			}
		},
		wantToAllotSamplePaginationCurrentChange(val) {
			this.wantToAllotSamplePagination.pageNo = val;
			if (this.chooseUserId == 'all') {
				this.queryWantToAllotSampleList();
			} else {
				this.queryAllotSampleList(this.chooseUserId);
			}
		},
		queryWantToAllotSampleList() {
			let data = {
				surveyId: this.id,
				currentPage: this.wantToAllotSamplePagination.pageNo,
				pageSize: this.wantToAllotSamplePagination.pageSize,
				source:this.source
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryWantToAllotSampleList}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.allSamples = res.resultBody.total
						that.wantToAllotSampleListData = res.resultBody.resultJSONList;
						that.wantToAllotSamplePagination.total = res.resultBody.total;
					} else {
						that.wantToAllotSampleListData = [];
						that.wantToAllotSamplePagination.total = 0
						that.allSamples = 0
						that.$message.error(res.message);
					}
					if (that.InterviewerSamleCountData.length > 0 && that.InterviewerSamleCountData[0].userId == 'all') {
						that.InterviewerSamleCountData[0].count = that.allSamples
					}
				}
			};
			this.$util.request(params);
		},

		queryAllotSampleList(userId) {
			let data = {
				surveyId: this.id,
				currentPage: this.wantToAllotSamplePagination.pageNo,
				pageSize: this.wantToAllotSamplePagination.pageSize,
				userId: userId == undefined ? '' : userId,
				source:this.source
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllotSampleList}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.wantToAllotSampleListData = res.resultBody.resultJSONList || res.resultBody;
						that.wantToAllotSamplePagination.total = res.resultBody.total || res.resultBody.length;
					} else {
						that.wantToAllotSampleListData = [];
						that.wantToAllotSamplePagination.total = 0
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 已被指派样本列表 end ↑
		// 选择访员
		chooseInterviewer(scope) {
			console.log(scope.userId);
			this.wantToAllotSamplePagination.pageNo = 1
			this.chooseUserId = scope.userId;
			if (this.chooseUserId == 'all') {
				this.queryWantToAllotSampleList();
			} else {
				this.queryAllotSampleList(scope.userId);
			}
		},
		queryInterviewerSamleCount() {
			let data = {
				surveyId: this.id,
				source:this.source
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryInterviewerSamleCount}`,
				method: 'POST',
				data: data,
				cb(res) {
					let all = {
						count: that.allSamples,
						userId: 'all',
						userName: '全部样本'
					}
					if (res.code == 0) {
						that.InterviewerSamleCountData = [all, ...res.resultBody];
					} else {
						that.InterviewerSamleCountData = [all];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},

		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style scoped lang="scss">
.sampleAssignment {
	margin: 0px;
	padding: 0px;
	width: 100%;
	height: 100%;
	.details_header {
		// max-width: 1200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background-color: #0080ff;
		margin: auto;
		display: flex;
		justify-content: space-between;
		span {
			// color: #333333;
			color: #fff;
			font-size: 16px;
			padding: 0px 30px;
		}
		margin-bottom: 20px;
		cursor: pointer;
	}
	.sampleAssignmentBox {
		width: 100%;
		.assigningBtn {
			padding: 0 20px;
			text-align: right;
		}
		.topTableBox {
			padding: 20px;
			display: flex;
			justify-content: space-between;
			.el-table {
				flex: none;
			}
			.topLeft {
				width: 200px;
				margin-right: 20px;
				.checkedTrue {
					cursor: pointer;
					color: #0080ff;
				}
				.checkedFalse {
					cursor: pointer;
				}
			}
			.topRight {
				width: calc(100% - 250px);
				flex: 1;
				.topRightTitle {
					display: flex;
					height: 25px;
					width: 500px;
					.shu {
						width: 3px;
						height: 25px;
						line-height: 25px;
						background-color: rgba(0, 136, 238, 1);
						text-align: center;
					}
					.title {
						margin-left: 10px;
						line-height: 25px;
						font-size: 20px;
					}
					margin-bottom: 20px;
				}
				.block {
					text-align: right;
					margin-top: 20px;
				}
			}
		}
		.botTableBox {
			padding: 20px;
			margin-top: 20px;
			.block {
				text-align: right;
				margin-top: 20px;
			}
		}
	}
}
</style>
